import React from "react";
import { WrapRootElement } from "./src/wrap-root-element";
import Layout from "./src/components/Layout";
import { getDocumentTitle } from "./src/utils/get-document-title";
import "./src/index.css";

function setDocumentTitle() {
  if (typeof window === "undefined") return;
  document.title = getDocumentTitle(window.location.pathname);
}

export const onInitialClientRender = () => {
  setDocumentTitle();
};

export const onRouteUpdate = () => {
  setDocumentTitle();
};

export const wrapRootElement = ({ element }) => (
  <WrapRootElement element={element} />
);

export const wrapPageElement = ({ element }) => <Layout>{element}</Layout>;
